
export class SeloRpeExclude {

    public id: Array<String>;
    public reason: string;
    public email: string;
}
